export default "__VITE_ASSET__Bnk7GH3T__"